import { type CSSProperties } from 'react';

type SkeletonProps = {
  /** 'chat-item' = sidebar chat row placeholder, 'message' = chat message content placeholder */
  variant?: 'chat-item' | 'message';
  /** Number of placeholders to render (e.g. 3 sidebar rows) */
  count?: number;
  style?: CSSProperties;
  className?: string;
};

/**
 * Shimmer placeholder for content that is still loading (sidebar chat rows,
 * markdown messages while the lazy chunk downloads). See .skeleton* in App.css.
 */
export default function Skeleton(props: SkeletonProps) {
  const { variant = 'chat-item', count = 1, style, className } = props;

  if (variant === 'chat-item') {
    return (
      <div className={['skeleton', className].filter(Boolean).join(' ')} style={style} aria-hidden="true">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="chat-item skeleton-row">
            <div className="skeleton-bar" style={{ width: `${55 + ((i * 17) % 30)}%` }} />
            <div className="skeleton-bar skeleton-bar--dot" />
          </div>
        ))}
      </div>
    );
  }

  // Message variant: a few text lines of varying width, mimicking a rendered message
  const widths = ['100%', '92%', '97%', '60%'];
  return (
    <div className={['skeleton', 'skeleton--message', className].filter(Boolean).join(' ')} style={style} aria-hidden="true">
      {Array.from({ length: Math.min(count, widths.length) }).map((_, i) => (
        <div key={i} className="skeleton-bar" style={{ width: widths[i] }} />
      ))}
    </div>
  );
}
